import { createContext, useContext, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

interface BookingWizardContextType {
  isOpen: boolean;
  openWizard: () => void;
  closeWizard: () => void;
}

const BookingWizardContext = createContext<BookingWizardContextType | undefined>(undefined);

export const BookingWizardProvider = ({ children }: { children: ReactNode }) => {
  const navigate = useNavigate();

  // Legacy openWizard now redirects to the new /book-now flow with overnight intent.
  const openWizard = () => navigate('/book-now?intent=overnight');
  const closeWizard = () => {};

  return (
    <BookingWizardContext.Provider value={{ isOpen: false, openWizard, closeWizard }}>
      {children}
    </BookingWizardContext.Provider>
  );
};

export const useBookingWizard = () => {
  const context = useContext(BookingWizardContext);
  if (context === undefined) {
    throw new Error('useBookingWizard must be used within a BookingWizardProvider');
  }
  return context;
};
